import React, { useEffect, useRef, useState } from 'react';
import { useApp } from '../../context/appContext';

const SearchField = ({ onPlaceSelected }) => {
  const { currentPage, setCurrentPage, searchTerm, setSearchTerm } = useApp();
  const hasFetchedPlace = useRef(false);
  const [isUserTyping, setIsUserTyping] = useState(false);

  const loadGoogleMapsScript = () => {
    return new Promise((resolve) => {
      if (typeof window.google !== 'undefined' && window.google.maps) {
        resolve();
      } else {
        const checkInterval = setInterval(() => {
          if (typeof window.google !== 'undefined' && window.google.maps) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
      }
    });
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (isUserTyping) return; // Don't override manual input

          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // Use Google Maps Geocoder to get the address
          const geocoder = new window.google.maps.Geocoder();
          const latLng = new window.google.maps.LatLng(lat, lng);

          geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
              const address = results[0].formatted_address;
              setSearchTerm(address);
              setCurrentPage('listing');
              onPlaceSelected({ location: results[0].geometry.location, lat, lng });
            }
          });
        },
        (error) => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  const handleSearch = () => {
    if (searchTerm) {
      setSearchTerm(searchTerm);
      if (currentPage === 'map') {
        setCurrentPage('listing');
      }
    }
  };

  useEffect(() => {
    loadGoogleMapsScript().then(() => {
      if (!isUserTyping) {
        getCurrentLocation();
        setIsUserTyping(true); 
      }

      const autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById('searchField'),
        {
          types: ['geocode'],
          componentRestrictions: { country: 'AU' },
        }
      );

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        setSearchTerm(place.formatted_address);
        setCurrentPage('listing');

        if (place.geometry) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          onPlaceSelected({ location: place.geometry.location, lat, lng });
        }
      });

      if (!hasFetchedPlace.current) {
        hasFetchedPlace.current = true;
        if (!searchTerm) return;

        const service = new window.google.maps.places.AutocompleteService();
        service.getPlacePredictions(
          { input: searchTerm, componentRestrictions: { country: 'AU' } },
          (predictions, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions.length > 0) {
              const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
              placesService.getDetails({ placeId: predictions[0].place_id }, (placeResult, placeStatus) => {
                if (placeStatus === window.google.maps.places.PlacesServiceStatus.OK && placeResult.geometry) {
                  const lat = placeResult.geometry.location.lat();
                  const lng = placeResult.geometry.location.lng();
                  setSearchTerm(placeResult.formatted_address);
                  onPlaceSelected({ lat, lng });
                  setCurrentPage('listing');
                }
              });
            }
          }
        );
      }
    });
  }, [onPlaceSelected, searchTerm, setCurrentPage, setSearchTerm, isUserTyping]);

  return (
    <div className="search-container">
      <input
        id="searchField"
        type="text"
        placeholder="Postcode/Suburb/Town"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setIsUserTyping(true); // User is manually typing
        }}
      />
      <i className="fa fa-search search-icon" onClick={handleSearch}></i>
    </div>
  );
};

export default SearchField;
